<template>
                <div class="agreement-letter" v-if="version == '1.0'">
                    <div class="agreement-letter__header">
                        <div class="agreement-letter__ribbon" :class="{'agreement-letter__ribbon--new': !isOld}">
                            <p v-if="!isOld">Gældende</p>
                            <p v-if="isOld">Udløbet</p>
                        </div>
                        <div class="agreement-letter__client-info">
                            <span v-text="letterData.fullname"></span>
                            <span v-text="letterData.address"></span>
                            <span>{{ letterData.postal}} {{ letterData.city }}</span>
                        </div>
                        <div class="agreement-letter__agreement-info">
                            <span>{{ letterData.date }}</span>
                            <span>Sagsnr.: {{ letterData.caseid }}</span>
                        </div>
                    </div>
                    <div class="agreement-letter__body">
                        <h2>Kære {{ letterData.fullname }}</h2>
                        <p>Vi bekræfter herved vores assistance i forbindelse med {{ letterData.producttxt }}{{ addonsStr }}.</p>
                        <div class="agreement-letter__grid">
                            <div class="agreement-checkbox" v-for="line in letterData.contract_lines" v-if="line">
                                <span class="agreement-checkbox__check"></span>
                                <span class="agreement-checkbox__text">{{ line }}</span>
                            </div>
                        </div>
                        <p v-if="letterData.notice" v-text="letterData.notice"></p>

                        <p><span v-html="customerDepartmentTxt"></span> er underlagt hvidvaskingslovens regler omkring identifikation af kundeforhold. Du skal som ny kunde CPR-validere dig via denne grønne knap på din sagsoversigt. Dette skal kun ske én gang.</p>
                        <p v-if="letterData.responsible">Din sagsbehandling vil blive varetaget af {{ letterData.responsible }} <span v-if="letterData.assistant"> og {{ letterData.assistant }}</span>.</p>
                        
                        <h3 v-if="letterData.price_method > 0">Pris</h3>
                        <p v-if="letterData.price_method == 1">Vores honorar for denne opgave udgør en fast aftalt pris på <span v-price="letterData.price"></span> <b>inkl. moms.</b> <span v-if="letterData.discountPercent > 0">Rabat {{ letterData.discountPercent }}%.</span> Moms udgør heraf <span v-price="vat"></span> <template v-if="letterData.other_case">Afregning sker på anden sag.</template> <template v-if="letterData.against_capital">Vores honorar og gebyr til Erhvervsstyrelsen modregnes i den indbetalte selskabskapital.</template></p>
                        <p v-if="letterData.price_method == 2">
                            Vores honorar for denne opgave afregnes som aftalt efter medgået tid. Prisen udgør kr. 1.250,00 - 3.750,00 <b>inkl. moms</b> i timen. Enhver opgave vil blive tilrettelagt således, at vi inddrager personale med lavere timetakster, til at bistå med arbejde, hvor det skønnes hensigtsmæssigt. Det er altid muligt, at få oplyst sagens løbende omkostninger.
                        </p>

                        <p v-if="letterData.tax > 0">Afgifter/gebyrer udgør <span v-price="letterData.tax"></span>, momsfrit.</p>

                        <h3>Deponering</h3>
                        <template v-if="letterData.deposit_method === 1">
                            <p>Til sikkerhed for vores honorar og kendte omkostninger bedes <span v-price="letterData.deposit_price"></span> indsættes på vores klientkonto i Nykredit med reg.nr. 8117 og konto nr. 3822677. Navngiv venligst overførslen {{ letterData.caseid }}.</p>
                            <p>Din indbetaling registreres indenfor 1-2 bankdage. Vores kvittering herfor vil fremgå i dit NEMBLIK på sagen, og du vil modtage en kvittering til din e-mail.</p>
                            <p>Vi vil høfligt påminde om beløbet indtil deponering er modtaget. Krydser vores påmindelser din indbetaling, skal du naturligvis set bort fra disse.</p>
                        </template>
                        
                        <p v-if="letterData.deposit_method === 0">Efter aftale skal der ikke foretages deponering forud for sagens opstart.</p>

                        <h3 v-if="(letterData.tinglysning && letterData.tinglysning !== 'none')">Tinglysning</h3>
                        <template v-if="letterData.tinglysning === 'TL'">
                            <p>Der skal i forbindelse med handlen betales en fast tinglysningsafgift på kr. 1.750,00 til staten. Afgiften reguleres af tinglysningsafgiftsloven. Afgiften indkræves sammen med vores honorar. Dette er indsat under pris ovenfor.</p>
                        </template>

                        <template v-if="letterData.tinglysning === 'TLPLUS'">
                            <p>Der skal i forbindelse med handlen betales to typer tinglysningsafgift. En fast afgift på kr. 1.750,00 og en variable afgift. Der gælder forskellige regler for hvordan den variable afgift beregnes.</p>
                            <p>I almindelig fri handel udgør den variable afgift 0,6% af købesummen.</p>
                            <p>Hvis ejerskiftet ikke er sket som almindelig fri handel, f.eks. ved familiehandel, skal der kun betales tinglysningsafgift af 85% af ejendomsværdien, hvis købesummen er mindre end dette beløb - ellers sker beregningen af købesummen.</p>
                            <p>Ved handel af erhvervsejendomme og  landbrugsejendomme beregnes den variable tinglysningsafgift af enten købesummen eller den offentlige ejendomsvurdering, hvad end der er højest af de to.</p>
                            <p>Tinglysningsafgifterne er i alle tilfælde først endelige, når handelsværdien på ejendommen er fastsat. Afgifterne reguleres af tinglysningsafgiftsloven.</p>
                        </template>

                        <template v-if="letterData.tingopkrav && letterData.tingopkrav === 'TLNEM'">
                            <p>Tinglysningsafgiften opkræves af <span v-html="customerDepartmentTxt"></span>, senest en uge før skødets tinglysning. Afgiften opkræves særskilt pr. e-mail og i dit <b>NEM</b>BLIK.</p>
                        </template>

                        <template v-if="letterData.tingopkrav && letterData.tingopkrav === 'TLMOD'">
                            <p>Tinglysningsafgiften opkræves i følge aftale, ikke af <span v-html="customerDepartmentTxt"></span> i denne sag.</p>
                        </template>

                        <template v-if="(letterData.tinglysning && letterData.tinglysning !== 'none')">
                            <h3>Forbehold ved debitorskifte</h3>
                            <p><span v-html="customerDepartmentTxt"></span> tager forbehold for ekstra afgift, i det tilfælde, at der i forbindelse med handlen skal ske et ejerskifte af sikkerheden til ejerforeningen. Dette udløser en tinglysningsafgift til tinglysningsretten på kr. 1.750 pr. ekspedition.</p>
                            
                            <h3>Forbehold for bopælspligt</h3>
                            <p><span v-html="customerDepartmentTxt"></span> tager forbehold for ekstra afgift, i det tilfælde, du ikke opfylder reglerne om bopælspligt. Dette kan navnlig være relevant, såfremt du har været udrejst fra Danmark, og/eller er indrejst til Danmark, og i den forbindelse har fået tildelt et CPR-nr. indenfor de seneste 5 år. I sådant tilfælde, skal dette oplyses, således, at vi i anmeldelsen kan afgive behørig erklæring omkring din tilladelse til at erhverve fast ejendom. Manglende erklæring kan medføre en ekstra tinglysningsafgift på kr. 1.750,00.</p>
                        </template>
                        
                        <template v-if="letterData.nemreg_price_data">
                            <h3>Selskabskapital</h3>
                            <p>Selskabet stiftes med en kapital på <span v-price="letterData.nemreg_price_data.capital"></span> til kurs {{ letterData.nemreg_price_data.exchange_rate }}, hvilket svarer til et samlet indskud på <span v-price="letterData.nemreg_price_data.deposit"></span></p>
                            <p v-if="letterData.nemreg_price_data.type === 'deponering'">Dokumentation for selskabskapitalen sker ved deponering af det samlede indskud på <span v-html="customerDepartmentTxt"></span>S klientkonto. Se vejledning til indbetaling under afsnittet Deponering ovenfor.</p>
                            <p v-if="letterData.nemreg_price_data.type === 'rullende_kapital'">Selskabskapitalen dokumenteres ved indskud af indestående kapital fra et holdingselskab på samme ordre. Dette kaldes også ”at rulle kapitalen”. <span v-html="customerDepartmentTxt"></span> tilsikrer, at kapitalen flyttes fra holdingselskabets sag til nærværende sag i forbindelse med stiftelsen.</p>
                            <p v-if="letterData.nemreg_price_data.type === 'vaerdier'">Selskabskapitalen dokumenteres ved, at fremsende gyldig vurderingsberetning på de indskudte aktiver. Vurderingsberetningen skal være udarbejdet af en uvildig registreret revisor.</p>
                            <p v-if="letterData.nemreg_price_data.type === 'bank'">Selskabskapitalen dokumenteres ved at fremsende en bankposteringsoversigt, der viser at selskabskapitalen inklusiv eventuelt tillæg af overkurs, indestår på en erhvervskonto tilhørende selskabet under stiftelse. Posteringsoversigten skal være stemplet og underskrevet af banken. Den indeståede kapital skal være tilstede på erhvervskontoen med registreringstidspunktet.</p>
                            <p v-if="letterData.nemreg_price_data.type === 'erklaering'">Selskabskapitalen dokumenteres ved, at stifter(e) underskriver en af <span v-html="customerDepartmentTxt"></span> tilsendt egen-erklæring. Ved underskrift af erklæringen, indestår stifter for, at selskabskapitalen er tilstede ved stiftelsen.</p>
                        </template>

                        <h3 v-if="letterData.insurance">Forsikringsforbehold</h3>
                        <p v-if="letterData.insurance">Det skal afklares hvorvidt der retshjælp i jeres indboforsikring. Kan der opnås tilsagn fra dit forsikringsselskab til retshjælpsdækning, vil honorar for de indenretlige skridt, blive opkrævet hos dit forsikringsselskab. Udenretlige omkostninger der ikke er dækket af din retshjælpsforsikring opkræves direkte hos dig.</p>
                        
                        <h3>Generelle forretningsbetingelser</h3>
                        <p>Der henvises i øvrigt til vores almindelige forretningsbetingelser, der findes <a href="https://www.nemadvokat.dk/om-nemadvokat/forretningsbetingelser/" target="_blank">her</a>.</p>
                    </div>
                </div>
                <div v-else-if="version === '2.0'" ref="agreementletter" class="agreement-letter" v-html="letterData.letterstring"></div>
</template>

<script>
export default {
  props: {
      customerDepartment: {type: Number|String, default: 0},
      isOld: {type: Boolean, default: false},
      letterData: {type: Object, default() {return {
          caseid: '',
          fullname: '',
          address: '',
          postal: '',
          city: '',
          date: '',
          producttxt: '',
          addons: [ ],
          contract_lines: [ ],
          responsible: '',
          assistant: '',
          price: 0,
          discount: 0,
          discountPercent: 0,
          price_method: 0,
          deposit_method: 0,
          deposit_price: 0,
          tinglysning: '',
          tax: 0,
          insurance: false,
          notice: '',
          tingopkrav: '',
          debitor_shift: false,
          residence_requirement: false,
          other_case: false,
          nemreg_price_data: {
            type: 'beregning',
            exchange_rate: 0,
            capital: 0,
            deposit: 0
          },
          against_capital: false
      }}}
  },
  mounted() {
    this.addRibbon();
  },
  watch: {
      version() {
          this.$nextTick(() => {
            this.addRibbon();
          })
      },
      isOld() {
          this.$nextTick(() => {
            this.addRibbon();
          })
      }
  },
  methods: {
      addRibbon() {
          if(this.version !== '2.0')
            return;

          let header = this.$refs.agreementletter.getElementsByClassName('agreement-letter__header');
          let ribbon = document.createElement('div');
          ribbon.innerHTML = (this.isOld) ? '<p>Udløbet</p>' : '<p>Gældende</p>';
          ribbon.classList.add('agreement-letter__ribbon');
          if(!this.isOld) {
              ribbon.classList.add('agreement-letter__ribbon--new');
          }
          header[0].appendChild(ribbon);
      }
  },
  computed: {
      version() {
        return (this.letterData.version) ? this.letterData.version : '1.0';
      },
    customerDepartmentTxt() {
        switch(parseInt(this.customerDepartment)) {
            case 1:
                return 'STØTTRUP';
            default:
                return '<b>NEM</b>ADVOKAT';
        }
      },
      vat() {
          return this.letterData.price * 0.20;
      },
      addonsStr() {  
          let str = ''; 
          let addonsNumber = this.letterData.addons.length;
          if(addonsNumber > 0) {
              str += ', '
          }

          for(let i in this.letterData.addons) {
            if(i < addonsNumber - 1) {
                str += this.letterData.addons[i] + ' ,';
            } else {
                str += ' og ' + this.letterData.addons[i];
            }
          }

          return str;
      }
  }
}
</script>
